import { CssBaseline } from "@mui/material";
import * as React from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
  useLocation,
  Outlet,
} from "react-router-dom";
import AuthProvider, { useAuth } from "./contexts/AuthContext";
import TimesheetProvider from "./contexts/TimesheetContext";
import DashboardLayout from "./layouts/DashboardLayout";
import ManageCustomers from "./routes/Customers";
import SignIn from "./routes/Login";
import ResetPassword from "./routes/ResetPassword";
import Timesheet from "./routes/Timesheet";
import ManageUsers from "./routes/Users";
import LedgerPage from "./routes/Finances/LedgerPage";
import LedgerTransactionsPage from "./routes/Finances/LedgerTransactionsPage";
import LedgerClassificationsPage from "./routes/Finances/LedgerClassificationsPage";
import LedgerProjectionPage from "./routes/Finances/LedgerProjectionPage";
import ProjectionProvider from "./contexts/ProjectionContext";

// 34840e45-0c9c-487a-8ba4-aeb67b353a11
// https://www.robinwieruch.de/react-router-private-routes/
// https://github.com/remix-run/react-router/blob/dev/examples/auth/src/App.tsx
const ProtectedLayout = () => {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.isAuthenticated && !auth.isLoggingOut) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />;
  }

  return (
    <TimesheetProvider>
      <DashboardLayout />
    </TimesheetProvider>
  );
};

export default function App() {
  const router = createBrowserRouter([
    {
      path: "sign-in",
      element: <SignIn />,
    },
    {
      path: "reset-password/:resetPasswordToken",
      element: <ResetPassword />,
    },
    {
      path: "/",
      element: <ProtectedLayout />,
      children: [
        {
          index: true,
          element: <Timesheet />,
        },
        {
          path: "timesheet",
          element: <Timesheet />,
        },
        {
          path: "customers",
          element: <ManageCustomers />,
        },
        {
          path: "users",
          element: <ManageUsers />,
        },
        {
          path: "finances/projections",
          element: (
            <ProjectionProvider>
              <LedgerProjectionPage />
            </ProjectionProvider>
          ),
        },
        {
          path: "finances/classifications/:parentId?",
          element: <LedgerClassificationsPage />,
        },
        {
          path: "finances/ledger",
          element: <LedgerPage />,
        },
        {
          path: "finances/ledger/:ledgerId",
          element: <LedgerTransactionsPage />,
        },
      ],
    },
  ]);

  return (
    <AuthProvider>
      <CssBaseline />
      <RouterProvider router={router} />
    </AuthProvider>
  );
}
